function randomizeNumber() {
  return Math.ceil(Math.random() * 6);
}

function randomizeAngle() {
  return Math.ceil(Math.random() * 360);
}

function generateDice(id) {
  return {
    id: id,
    number: randomizeNumber(),
    angle: randomizeAngle(),
    position: {
      x: 0,
      y: 0
    },
    hold: false
  };
}

function generateDices(nbDices) {
  const dices = [];
  for (let i = 0; i < nbDices; i++) {
    dices.push(generateDice(i));
  }
  return dices;
}

function updateDices(dices) {
  const updatedDices = [];
  for (let i = 0; i < dices.length; i++) {
    let dice = dices[i];

    if (!dice.hold) {
      dice = generateDice(i);
      dice.position = dices[i].position;
    }

    updatedDices.push(dice);
  }
  return updatedDices;
}

export {
  generateDice,
  generateDices,
  updateDices,
  randomizeNumber,
  randomizeAngle
};
